// extracted by mini-css-extract-plugin
export default {"red-text":"ContextMenuItems_red-text__atuSL","online_booking":"ContextMenuItems_online_booking__iFmzy"};